/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontype from './actionTypes';

const initstate = {};

const reducer = (state = initstate, action) => {
  switch (action.type) {
    case actiontype.CHECK_PAYEE_CD:
      return { ...state, check_pay: action.payload };
    case actiontype.STATE_CD:
      return { ...state, state_cd: action.payload };
    case actiontype.ADJUSTMENT_QTR_CD:
      return { ...state, adjustment_qtr: action.payload };
    case actiontype.DAY_COUNT_METHOD_CD:
      return { ...state, day_count: action.payload };
    case actiontype.DRUG_TYPE_SOURCE_CD:
      return { ...state, drug_type_src: action.payload };
    case actiontype.ADJUSTMENT_DISPUTE_CD:
      return { ...state, dispute_code: action.payload };
    case actiontype.UNIT_TYPE_CD:
      return { ...state, unit_type: action.payload };
    case actiontype.REBATE_UNIT_TYPE_CD:
      return { ...state, rebate_unit_type: action.payload };
    case actiontype.COVER_LETTER_PLACEMENT_CD:
      return { ...state, cover_letter: action.payload };
    case actiontype.NON_CMS_DRUG_INCL_CD:
      return { ...state, cms_drug: action.payload };
    case actiontype.URA_SOURCE_CD:
      return { ...state, ura_source: action.payload };
    case actiontype.URA_CALC_METHOD_CD:
      return { ...state, ura_calc: action.payload };
    case actiontype.INT_CALC_METHOD_CD:
      return { ...state, int_calc: action.payload };
    case actiontype.DETAIL_LEVEL_ON_INVOICE_CD:
      return { ...state, detail_lvl: action.payload };
    case actiontype.DISPUTE_SPECIALISTS:
      return { ...state, specialists: action.payload };
    case actiontype.GET_LETTER_SENDERS:
      return { ...state, letter_sender: action.payload };
    case actiontype.ENROLLMENT_TIMING_CD:
      return { ...state, enroll_time: action.payload };
    case actiontype.CLAIM_REBATE_PGM_CD:
      return { ...state, claim_code: action.payload };
    case actiontype.DEFAULT_SYS_AUDIT:
      return { ...state, def_sys_aud: action.payload };
    default:
      return state;
  }
};

export default reducer;
